<template>
  <div
    class="relative rounded-lg overflow-hidden border bg-white border-gray-200 shadow-sm"
  >
    <button
      class="absolute top-0 right-0 px-2 py-1 rounded-bl-md bg-gray-200 bg-opacity-70"
    >
      <img alt="" class="h-6 w-6" src="@/assets/icons/ordersfillmustard.svg" />
    </button>
    <div class="px-2 background">
      <p class="font-bold text-left">{{ order.orderReference }}</p>
      <div class="flex space-x-4 mx-6 font-medium justify-center">
        <p class="text-left text-sm">
          Date: {{ $store.getters.toDate(order.orderTime) }}
        </p>
        <p class="text-left text-sm">
          Time: {{ $store.getters.toTime(order.orderTime) }}
        </p>
      </div>
    </div>

    <!-- DESCRIPTION -->
    <div class="grid grid-cols-2 text-left p-2">
      <p
        v-for="item in order.orderItems"
        :key="item"
        class="text-xxs text-black"
      >
        {{ item.title }}
        <span class="">(x{{ item.quantity }})</span>
      </p>
    </div>
    <div class="grid grid-cols-2 p-2 text-whited">
      <p class="bg-white bg-opacity-60 font-medium text-bnb-brown text-lg">
        ₦ {{ order.amount }}
      </p>
      <button
        v-if="customerHasAccess"
        class="bg-gray-100 font-semibold rounded-md"
        @click="details"
      >
        Details
      </button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
export default {
  props: { order: Object },
  data() {
    return {
      rating: 0,
      // STARS
      star: require("@/assets/icons/orders/star.svg"),
      starfilled: require("@/assets/icons/orders/starfilled.svg"),
      // icons
      placedIcon: require("@/assets/icons/orders/placed.svg"),
      preparingIcon: require("@/assets/icons/orders/preparing.png"),
      transitIcon: require("@/assets/rider.png"),
      completedIcon: require("@/assets/icons/orders/completed.svg"),
      cancelledIcon: require("@/assets/icons/orders/cancelled.svg"),
    };
  },
  computed: {
    customerHasAccess() {
      return firebase.auth().currentUser.uid == this.order.customerID;
    },
    icon() {
      if (this.order.status == "Placed") {
        return this.completedIcon;
      } else if (this.order.status == "Preparing") {
        return this.preparingIcon;
      } else if (this.order.status == "In Transit") {
        return this.transitIcon;
      } else if (this.order.status == "Cancelled") {
        return this.cancelledIcon;
      } else {
        return this.completedIcon;
      }
    },
  },
  methods: {
    getStar(index) {
      if (index + 1 <= this.rating) {
        return this.starfilled;
      } else {
        return this.star;
      }
    },
    track() {
      if (this.order.status.toString() == "In Transit".toString()) {
        alert(this.order.status);
      } else {
        alert("Not Available");
      }
      // this.$router.push({ name: "TrackOrder" });
    },
    details() {
      this.$router.push({
        name: "OrderDetails",
        params: { orderReference: this.order.orderReference },
      });
    },
  },
};
</script>
